// extracted by mini-css-extract-plugin
export default {"wrapper":"text_wrapper__oNyu-","input":"text_input__1xuBW"};